export default __webpack_public_path__ + "static/media/menu-collect-active.d8cdf0b0.svg";